//Use CommonJS style via browserify to load other modules
require("./lib/social");
require("./lib/ads");

var ich = require("icanhaz");
var $ = require("jquery");

var templateFile = require("./_template.html");
ich.addTemplate("template", templateFile);

$(document).ready( function() {

  var data = [
    { "year": 1977, "last_name": "Stanton", "batting_avg": ".275", "class":"norepeat", "homeruns": 27, "rbi": 90, "salary": 75000 },
    { "year": 1978, "last_name": "Bochte", "batting_avg": ".263", "class":"repeat", "homeruns": 11, "rbi": 51, "salary": 126000 },
    { "year": 1979, "last_name": "Horton", "batting_avg": ".279", "class":"norepeat", "homeruns": 29, "rbi": 106, "salary": 106500 },
    { "year": 1980, "last_name": "Bochte", "batting_avg": ".300", "class":"repeat", "homeruns": 13, "rbi": 78, "salary": 126000 },
    { "year": 1981, "last_name": "Zisk", "batting_avg": ".311", "class":"repeat", "homeruns": 16, "rbi": 43, "salary": 312500 },
    { "year": 1982, "last_name": "Zisk", "batting_avg": ".292", "class":"repeat", "homeruns": 21, "rbi": 62, "salary": 312500 },
    { "year": 1983, "last_name": "Zisk", "batting_avg": ".242", "class":"repeat", "homeruns": 12, "rbi": 36, "salary": 272500 },
    { "year": 1984, "last_name": "Phelps", "batting_avg": ".241", "class":"repeat", "homeruns": 24, "rbi": 51, "salary": 180000 },
    { "year": 1985, "last_name": "Thomas", "batting_avg": ".215", "class":"norepeat", "homeruns": 32, "rbi": 87, "salary": 690000 },
    { "year": 1986, "last_name": "Phelps", "batting_avg": ".247", "class":"repeat", "homeruns": 24, "rbi": 64, "salary": 235000 },
    { "year": 1987, "last_name": "Phelps", "batting_avg": ".259", "class":"repeat", "homeruns": 27, "rbi": 68, "salary": 300000 },
    { "year": 1988, "last_name": "Davis", "batting_avg": ".295", "class":"norepeat", "homeruns": 18, "rbi": 69, "salary": 887500 },
    { "year": 1989, "last_name": "Leonard", "batting_avg": ".254", "class":"repeat", "homeruns": 24, "rbi": 93, "salary": 1000000 },
    { "year": 1990, "last_name": "Leonard", "batting_avg": ".251", "class":"repeat", "homeruns": 10, "rbi": 75, "salary": 800000 },
    { "year": 1991, "last_name": "O'Brien", "batting_avg": ".248", "class":"norepeat", "homeruns": 17, "rbi": 88, "salary": 2037500 },
    { "year": 1992, "last_name": "Mitchell", "batting_avg": ".286", "class":"norepeat", "homeruns": 9, "rbi": 67, "salary": 3750000 },
    { "year": 1993, "last_name": "Buhner", "batting_avg": ".272", "class":"repeat", "homeruns": 27, "rbi": 98, "salary": 2772500 },
    { "year": 1994, "last_name": "Buhner", "batting_avg": ".279", "class":"repeat", "homeruns": 21, "rbi": 68, "salary": 4350000 },
    { "year": 1995, "last_name": "Buhner", "batting_avg": ".262", "class":"repeat", "homeruns": 40, "rbi": 121, "salary": 4066666 },
    { "year": 1996, "last_name": "Martinez", "batting_avg": ".327", "class":"repeat", "homeruns": 26, "rbi": 103, "salary": 3500000 },
    { "year": 1997, "last_name": "Martinez", "batting_avg": ".330", "class":"repeat", "homeruns": 28, "rbi": 108, "salary": 3050000 },
    { "year": 1998, "last_name": "Martinez", "batting_avg": ".322", "class":"repeat", "homeruns": 29, "rbi": 102, "salary": 3500000 },
    { "year": 1999, "last_name": "Martinez", "batting_avg": ".337", "class":"repeat", "homeruns": 24, "rbi": 86, "salary": 3500000 },
    { "year": 2000, "last_name": "Martinez", "batting_avg": ".324", "class":"repeat", "homeruns": 37, "rbi": 145, "salary": 5400000 },
    { "year": 2001, "last_name": "Olerud", "batting_avg": ".302", "class":"norepeat", "homeruns": 21, "rbi": 95, "salary": 6700000 },
    { "year": 2002, "last_name": "Martinez", "batting_avg": ".277", "class":"repeat", "homeruns": 15, "rbi": 59, "salary": 7086668 },
    { "year": 2003, "last_name": "Martinez", "batting_avg": ".294", "class":"repeat", "homeruns": 24, "rbi": 98, "salary": 4000000 },
    { "year": 2004, "last_name": "Ibanez", "batting_avg": ".304", "class":"repeat", "homeruns": 16, "rbi": 62, "salary": 3916667 },
    { "year": 2005, "last_name": "Sexson", "batting_avg": ".263", "class":"norepeat", "homeruns": 39, "rbi": 121, "salary": 6000000 },
    { "year": 2006, "last_name": "Ibanez", "batting_avg": ".289", "class":"repeat", "homeruns": 33, "rbi": 123, "salary": 4250000 },
    { "year": 2007, "last_name": "Ibanez", "batting_avg": ".291", "class":"repeat", "homeruns": 21, "rbi": 105, "salary": 5500000 },
    { "year": 2008, "last_name": "Beltre", "batting_avg": ".266", "class":"norepeat", "homeruns": 25, "rbi": 77, "salary": 13400000 },
    { "year": 2009, "last_name": "Griffey", "batting_avg": ".214", "class":"norepeat", "homeruns": 19, "rbi": 57, "salary": 2000000 },
    { "year": 2010, "last_name": "Lopez", "batting_avg": ".239", "class":"norepeat", "homeruns": 10, "rbi": 58, "salary": 3000000 },
    { "year": 2011, "last_name": "Carp", "batting_avg": ".276", "class":"norepeat", "homeruns": 12, "rbi": 46, "salary": 488800 },
    { "year": 2012, "last_name": "Montero", "batting_avg": ".260", "class":"norepeat", "homeruns": 15, "rbi": 62, "salary": 486900 },
    { "year": 2013, "last_name": "Morales", "batting_avg": ".277", "class":"repeat", "homeruns": 23, "rbi": 80, "salary": 5250000 },
    { "year": 2014, "last_name": "Morales", "batting_avg": ".218", "class":"repeat", "homeruns": 8, "rbi": 42, "salary": 7410000 }
  ];



  data.forEach(function(row) {
    row.hrwidth = row.homeruns * 1.1;
    row.rbiwidth = row.rbi * .5;
     row.formattedSalary = row.salary.toLocaleString().replace("/\.0+/", "");

  });
  
  var table = ich.template({ 
    "users": data });
  $('#container').append(table);

  var sortOrder = 1;
  var lastSort = null;

  $("#container").on("click", "th", function(e) {
    
    var index = e.target.id;

    if (lastSort == index) { 
      sortOrder *= -1;
      console.log('down');

    } else {
      lastSort = index;
      sortOrder = 1;
      console.log("up");
    }

    data.sort(function(a,b) {
      a = index == "last_name" ? a[index].toLowerCase() : a[index] * -1;
      b = index == "last_name" ? b[index].toLowerCase() : b[index] * -1;

      if (a < b) {
        return -1 * sortOrder;
      } else if (a > b) {
        return 1 * sortOrder;
      } else if (a == b) {
        return 0;
      }
    });
    $('#container').html(ich.template({ "users": data }));

  });

});

